document.addEventListener("DOMContentLoaded", function () {
  var stickyCTA = document.getElementById("sticky-cta");
  var cta = document.querySelector(".block-buy-buttons");

  if (!stickyCTA || !cta) {
    return;
  }

  // CRITICAL: Force hide the sticky CTA initially and keep it hidden
  stickyCTA.style.display = "none";

  // Function to show sticky CTA (only when we're sure buy buttons are above viewport)
  function showStickyCTA() {
    var rect = cta.getBoundingClientRect();
    // Only show if buy buttons are completely above the viewport (scrolled past them)
    if (rect.bottom <= 0) {
      stickyCTA.style.display = "block";
    }
  }

  // Function to hide sticky CTA
  function hideStickyCTA() {
    stickyCTA.style.display = "none";
  }

  // Use scroll event instead of intersection observer for more control
  window.addEventListener("scroll", function () {
    var rect = cta.getBoundingClientRect();

    // Show sticky CTA when buy buttons are completely above the viewport (scrolled past them)
    if (rect.bottom <= 0) {
      showStickyCTA();
    } else {
      // Hide sticky CTA when buy buttons are visible or partially visible
      hideStickyCTA();
    }
  });

  // Check initial state
  setTimeout(function () {
    var rect = cta.getBoundingClientRect();

    // Only show if buy buttons are completely above viewport (scrolled past them)
    if (rect.bottom <= 0) {
      showStickyCTA();
    } else {
      hideStickyCTA();
    }
  }, 100);

  // Also hide on window resize
  window.addEventListener("resize", function () {
    setTimeout(function () {
      var rect = cta.getBoundingClientRect();
      if (rect.bottom <= 0) {
        showStickyCTA();
      } else {
        hideStickyCTA();
      }
    }, 50);
  });
});
